export function getLabel(tags) {
  if (tags.length === 0) {
    return 'No tags selected'
  }

  if (tags.length === 1) {
    return tags[0].name
  }

  if (tags.length > 1) {
    return `${tags.length} selected`
  }
}
